// import request from './request';
// import Axios from 'axios'

// export const httpAjax = (params) => {
//   const json = params.method === undefined || params.method === 'get' ? { params: params.data } : { data: params.data };
//   return request({
//     url: params.url,
//     method: params.method,
//     ...json
//   });
// }

import serviceApi, { agentApi, baseApi } from './request';

export const httpAjax = params => {
  const json = params.method === undefined || params.method === 'get' ? { params: params.data } : { data: params.data };
  return serviceApi({
    url: params.url,
    method: params.method,
    ...json
  });
};

export const httpAgent = params => {
  const json = params.method === undefined || params.method === 'get' ? { params: params.data } : { data: params.data };
  return agentApi({
    url: params.url,
    method: params.method,
    ...json
  });
};

export const baseAgent = params => {
  const json = params.method === undefined || params.method === 'get' ? { params: params.data } : { data: params.data };
  return baseApi({
    url: params.url,
    method: params.method,
    ...json
  });
};
